import axios from 'axios';
import { userStatuses } from '../constants';

export const createNewUser = (newUser, firebase, firestore) => {
  return firebase
    .auth()
    .createUserWithEmailAndPassword(newUser.email, newUser.password)
    .then(resp => {
      const userProfile = {
        email: newUser.email,
        isCompany: newUser.companySignup,
        createdAt: firestore.FieldValue.serverTimestamp(),
        status: userStatuses.ACTIVE,
        signUpComplete: false
      };
      if (newUser.companySignup) {
        userProfile.profilePictureUrl = '/images/company-image.png';
        userProfile.companyName = newUser.companyName;
        userProfile.displayName = newUser.companyName;
      } else {
        userProfile.firstName = newUser.firstName;
        userProfile.lastName = newUser.lastName;
        userProfile.displayName = `${newUser.firstName} ${newUser.lastName}`;
      }

      firestore
        .collection('users')
        .doc(resp.user.uid)
        .set(userProfile);
      return resp.user.getIdToken();
    });
};

export const setCompanyClaim = (idToken, firebase) => {
  return axios
    .post(`${process.env.REACT_APP_FIREBASE_URL}/setCompanyClaims`, {
      idToken: idToken
    })
    .then(res => {
      if (res.status == 200 && res.data) {
        if (res.data && res.data.status == 'success') {
          // Force token refresh. The token claims will contain the additional claims.
          return firebase.auth().currentUser.getIdToken(true);
        }
      }
    });
};



// WEBPACK FOOTER //
// ./src/services/authServices.js